import React from "react";
import { useNavigate } from "react-router-dom";

export default function PackagesAdmin() {
  const navigate = useNavigate();

  return (
    <>
      <div>
        <h1 className="text-center text-2xl font-bold my-2">
          Admin for Packages
        </h1>
      </div>
      <div className="w-4/5">
        <div className="w-60">
          <button
            onClick={() => navigate("/packagesadmin/published")}
            className="text-base w-full md:text-xl p-1 md:p-2 text-white bg-green-400 hover:bg-green-500 active:bg-green-600"
          >
            Published Packages
          </button>
        </div>
        <div className="w-60">
          <button
            onClick={() => navigate("/packagesadmin/unpublished")}
            className="text-base w-full md:text-xl p-1 md:p-2 text-white bg-red-400 hover:bg-red-500 active:bg-red-600 my-1"
          >
            Unpublished Packages
          </button>
        </div>
      </div>
    </>
  );
}
